import React from 'react'
import CreateContractView from './CreateContractView'
import * as contractService from '../ContractsService'
import * as FlashMessage from '../../FlashMessage/FlashMessageConstants'

export default class CreateContract extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            contract: null,
            current: false,
            disableSubmit: false
        }
        this.handleContractChange = this.handleContractChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCurrentCheckboxChange = this.handleCurrentCheckboxChange.bind(this)
    }

    render() {
        return <CreateContractView 
            handleContractChange={this.handleContractChange}
            handleCurrentCheckboxChange={this.handleCurrentCheckboxChange}
            handleSubmit={this.handleSubmit}
            disableSubmit={this.state.disableSubmit}
            />
    }

    handleContractChange(event) {
        this.setState({
            contract: event.detail.value
        })
    }

    handleCurrentCheckboxChange(event) {
        this.setState({
            current: event.detail.checked
        })
    }

    handleSubmit() {
        this.setState({
            disableSubmit: true
        })
        this.createContract(this.state.contract, this.state.current)
    }

    createContract = (contract, current) => {
        const { newContract, setFlashMessage } = this.props
        return contractService.createContract(contract)
            .then(response => {
                newContract(true)
                setFlashMessage(FlashMessage.CreateContractSuccess)
                if (current) {
                    this.setContractAsCurrent(response)
                } else {
                    this.props.history.push("/contracts/" + response)
                }
            })
            .catch(() => {
                setFlashMessage(FlashMessage.CreateContractFailed)
                this.setState({disableSubmit: false})
            })
    }

    setContractAsCurrent = (contractId) => {
        const { newContract, setFlashMessage } = this.props
        return contractService.setContractAsCurrent(contractId)
            .then(() => {
                newContract(true)
            })
            .catch(() => {
                setFlashMessage(FlashMessage.ActivateContractFailed)
            })
            .finally(() => {
                this.props.history.push("/contracts/" + contractId)
            })
    }

}


// WEBPACK FOOTER //
// ./src/components/Contracts/Create/CreateContract.jsx